import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Token } from '../models/token.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class TokenService {

  constructor(private http: HttpClient) { }

  public getToken$() {

    const urlMe = environment.HOST + environment.SECURITY_API + 'security/login';
    const datos: Token = JSON.parse(localStorage.getItem('datos'));
    return this.http.post(urlMe, {
      "organizacion": datos.organizacion,
      "password": datos.password,
      "usuario": datos.usuario
    }, { responseType: 'text' });
  }
  public refreshToken$() {
    const urlMe = environment.HOST + environment.SECURITY_API + 'security/refresh-token';
    const token = localStorage.getItem('authorization');
    var fecha = new Date();
    var sumarsesion = environment.TIEMPO_TOTAL;
    var minutes = fecha.getMinutes();
    fecha.setMinutes(minutes + sumarsesion);
    localStorage.setItem('horaTope', fecha.getTime() + "");

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Accept', 'application/json');
    headers = headers.append('Authorization', token);
    return this.http.get(urlMe, { headers, responseType: 'text' });

  }
}
